import { UserCreateField } from 'common-front/src/components/users/create/userCreateField';
import { HorizontalSpacerSeparator } from 'common-front/src/designSystem/components/separator';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import {
    AccreditationsFormsCustomFieldInput,
    AttachCustomFieldFragment,
    FormCustomFieldFragment
} from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import { groupBy, sortBy, uniqBy } from 'lodash-es';
import * as React from 'react';
import { AttachFormCustomFields } from './attachFormCustomFields';

interface IAttachCustomFieldsProps {
    customFields: AttachCustomFieldFragment[];
    formCustomFields: FormCustomFieldFragment[];
    formCustomFieldsValues: AccreditationsFormsCustomFieldInput[];
    prefix: string;
    showFormCustomFields: boolean;

    change(name: string, value: any): void;
}

export const AttachCustomFields = (props: IAttachCustomFieldsProps) => {
    const {
        params: { organizationId }
    } = useHeavent();
    const categories = React.useMemo(
        () =>
            sortBy(
                uniqBy(
                    props.customFields.map((cf) => cf.category),
                    (c) => c.id
                ),
                (c) => c.name.toLowerCase()
            ),
        [props.customFields]
    );
    const categoryIdToCustomFields = React.useMemo(
        () => groupBy(props.customFields, (cf) => cf.category.id),
        [props.customFields]
    );

    return (
        <Flex direction="column">
            {categories.map((category, index) => {
                const customFields = categoryIdToCustomFields[category.id];

                return (
                    <React.Fragment key={category.id}>
                        {index !== 0 && <HorizontalSpacerSeparator height="5" />}

                        <Flex gap="7">
                            <Flex width={280}>
                                <Box font="gray800 textSm medium">{category.name}</Box>
                            </Flex>

                            <Flex css={{ flex: '1' }} direction="column" gap="4">
                                {customFields.map((customField) => (
                                    <UserCreateField
                                        key={customField.id}
                                        change={props.change}
                                        display={true}
                                        field={customField}
                                        fileAcl="public-read"
                                        isMandatory={false}
                                        organizationId={organizationId}
                                        prefix={`${props.prefix}fields.`}
                                    />
                                ))}
                            </Flex>
                        </Flex>
                    </React.Fragment>
                );
            })}

            {isNonEmptyArray(props.customFields) && props.showFormCustomFields && (
                <HorizontalSpacerSeparator height="5" />
            )}

            {props.showFormCustomFields && (
                <AttachFormCustomFields
                    change={props.change}
                    formCustomFields={props.formCustomFields}
                    formCustomFieldsValues={props.formCustomFieldsValues}
                    prefix={props.prefix}
                />
            )}
        </Flex>
    );
};
